<template>
    <div>
        <h2 class="text-lg-h5 font-weight-bold">Logs</h2>
        <v-row no-gutters>
            <v-col class="mt-4">
                <PublisherSelect store="logs"></PublisherSelect>
            </v-col>
        </v-row><!-- SITES SELECT -->
        <v-row no-gutters style="position: relative">
            <v-col cols="3">
                <div style="background:#fff; border-radius: 4px;" class="mr-4 mb-4 pa-4 pt-2">
                    <Input v-model.trim="search" label="Seiten suchen" class=""
                           append-icon="mdi-magnify" :hide-details="true"></Input>
                </div>
                <SitesList v-model="selectedSitetype" :show="showSitesList"
                           :items="publisher_sites" class="mr-4 logsSitetypesList"
                           style="max-height:578px;"></SitesList>
            </v-col>
            <v-col col="9">
                <Datatable :title="'Logs'+ (selectedSitetype ? ': '+selectedSitetype.Name : '')" :headers="headers"
                           :items="logs" :custom-sort="customSort">
                </Datatable>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import PublisherSelect from "./components/PublisherSelect";
import ada from "../scss/ada_colors.scss";
import SitesList from "./components/SitesList";
import Datatable from "../components/Tables/Datatable";
import Utils from "../scripts/Utils";
import Input from "../components/Inputs/Input";

export default {
    name: "Logs",
    components: {Input, Datatable, SitesList, PublisherSelect},
    data: () => {
        return {
            selectedSitetype: null,
            showSitesList: true,
            headers: [
                {text: 'Datum', value: 'Created'},
                {text: 'Class', value: 'ClassName'},
                {text: 'Beschreibung', value: 'Text'},
                {text: 'Bearbeiter', value: 'CreatedBy'},
            ],
            search: null,
            ada
        }
    },
    mounted() {
        this.fetchPublisher();
    },
    computed: {
        vuexState() {
            return this.$store.state.logs;
        },
        publisher() {
            return this.$store.state.display.publisher;
        },
        sitesAndTypes() {
            return this.vuexState.sitesAndTypes;
        },
        role() {
            return this.$store.state.users.role;
        },
        logs() {
            return this.vuexState.logs;
        },
        publisher_sites() {
            let ret = [];
            if (this.search && this.search !== '') {
                this.$store.getters['logs/publisher_sites'].forEach((publisher) => {
                    let tmpPublisher = JSON.parse(JSON.stringify(publisher));
                    tmpPublisher.sites = [];
                    publisher.sites.forEach((site) => {
                        if (site.Name.indexOf(this.search) !== -1) {
                            tmpPublisher.sites.push(site);
                        }
                    })
                    if (tmpPublisher.sites.length !== 0) {
                        ret.push(tmpPublisher);
                    }
                })
            } else {
                ret = this.$store.getters['logs/publisher_sites'];
            }
            return ret;
        }
    },
    methods: {
        fetchPublisher() {
            if (this.publisher === null) {
                this.$store.dispatch('display/fetchPublisher').then(() => {
                    this.fetchSitesAndTypes();
                });
            } else {
                this.fetchSitesAndTypes();
            }
        },
        fetchSitesAndTypes() {
            if (this.sitesAndTypes.length === 0) {
                this.$store.dispatch('logs/fetchSitesAndTypes');
            }
        },
        fetchLog() {
            this.$store.dispatch('logs/fetchLogs', this.selectedSitetype.SitetypeId);
        },
        customSort(items, index, isDescending) {
            // The following is informations as far as I researched.
            // items: 'food' items
            // index: Enabled sort headers value. (black arrow status).
            // isDescending: Whether enabled sort headers is desc
            items.sort((a, b) => {
                if (index[0] === 'Created') {
                    let tmpA = new Date(Utils.formatDateToIso(a.Created));
                    let tmpB = new Date(Utils.formatDateToIso(b.Created));
                    if (isDescending[0]) {
                        return Utils.compare(tmpB, tmpA);
                    } else {
                        return Utils.compare(tmpA, tmpB);
                    }
                }
            });

            return items;
        }
    },
    watch: {
        selectedSitetype() {
            this.fetchLog();
        },
    }
}
</script>

<style lang="scss" scoped>

::v-deep .logsSitetypesList {
    .v-list-item__title, .v-list-item__subtitle {
        white-space: pre-wrap;
    }
}

</style>